export default __webpack_public_path__ + "static/media/Email.8f14ecbd.png";